import React, { useEffect, useRef } from "react";

import { Document, Page } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css"; // CSS for PDF rendering
import PdfViewerModal from "../Auth/Registration/pdfViewerModal";
import { Modal } from "react-bootstrap";
import { CircularProgress } from "@mui/material";
import { renderAsync } from "docx-preview";

const UploadedDocument = ({
  fileData,
  fileType,
  handleCloseModal,
  isOpen,
  download,
  docx,
}) => {
  if (docx) {
    const DocxViewer = ({ fileData }) => {
      const viewerRef = useRef(null);

      useEffect(() => {
        if (fileData && viewerRef.current) {
          // Convert base64 to ArrayBuffer
          const byteCharacters = atob(fileData);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          renderAsync(byteArray.buffer, viewerRef.current, null, {
            inWrapper: false,
          });
        }
      }, [fileData]);

      const handleDownloadDocs = () => {
        const link = document.createElement("a");
        link.href = `data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,${fileData}`;
        link.download = "document.docx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };

      return (
        <Modal show={isOpen} size="lg" onHide={handleCloseModal} centered>
          <Modal.Header closeButton>
            <Modal.Title></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              style={{ height: "500px", overflowY: "scroll", padding: "8px" }}
            >
              <div onClick={handleDownloadDocs} className="download">
                Download
              </div>
              <div
                ref={viewerRef}
                style={{
                  border: "1px solid #ccc",
                }}
              />
            </div>
          </Modal.Body>
        </Modal>
      );
    };

    return <DocxViewer fileData={fileData} />;
  } else if (fileType !== "jpeg" && fileType !== "jpg" && fileType !== "png") {
    let fileUrl = `data:application/pdf;base64,${fileData}`;
    return (
      <div className="pdf-container">
        {isOpen && (
          <PdfViewerModal
            pdfUrl={fileUrl}
            handleCloseModal={handleCloseModal}
            isOpen={isOpen}
            download={download}
          />
        )}
      </div>
    );
  } else if (["jpeg", "png", "jpg"].includes(fileType)) {
    return (
      <Modal show={isOpen} size="lg" onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {fileData ? (
            <img
              src={`data:image/${fileType};base64,${fileData}`}
              alt="Uploaded Document"
              style={{ maxWidth: "100%", maxHeight: "100%" }}
            />
          ) : (
            <div className="text-center" style={{ maxHeight: "500px" }}>
              <CircularProgress />
            </div>
          )}
        </Modal.Body>
      </Modal>
    );
  } else {
    return <div>Unsupported file type</div>;
  }
};

export default UploadedDocument;
